import React, { useState } from 'react';
import { Check, Heart, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
function TopMarquee() {
  const items = ['15,000+ Happy Dog Parents', 'Rated "Excellent" on Trustpilot', 'Punishment-Free Method', 'Science-Based & Kind'];
  // Duplicate items so the marquee loops seamlessly at -50%
  const loop = [...items, ...items];
  return <div className="bg-[#003841] text-white/85 py-2.5 overflow-hidden relative" style={{
    WebkitMaskImage: 'linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)',
    maskImage: 'linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)'
  }} data-id="element-1606">
      <div className="flex w-max animate-marquee gap-12" data-id="element-1607">
        {loop.map((text, i) => <div key={i} className="flex items-center gap-2 whitespace-nowrap text-xs md:text-sm font-medium" data-id="element-1608">
            <span className="w-5 h-5 rounded-full bg-[#0E3A47] flex items-center justify-center flex-shrink-0" data-id="element-1609">
              <Heart className="w-3 h-3 text-[#95CBCD]" data-id="element-1610" />
            </span>
            <span data-id="element-1611">{text}</span>
          </div>)}
      </div>
    </div>;
}
function CurvedDivider({
  topColor,
  bottomColor,
  direction = 'down'
}: {
  topColor: string;
  bottomColor: string;
  direction?: 'up' | 'down';
}) {
  return <div className="relative w-full overflow-hidden leading-none" style={{
    backgroundColor: topColor
  }} data-id="element-1612">
      <svg className="relative block w-full h-[40px] md:h-[80px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 100" preserveAspectRatio="none" data-id="element-1613">
        {direction === 'down' ? <path d="M0,30 Q600,90 1200,30 L1200,100 L0,100 Z" fill={bottomColor} data-id="element-1614" /> : <path d="M0,70 Q600,10 1200,70 L1200,100 L0,100 Z" fill={bottomColor} data-id="element-1615" />}
      </svg>
    </div>;
}
export function WebinarMCPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-[#FBF1DC] font-sans text-[#0E3A47]" data-id="element-1616">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0E3A47]/60 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-1617">
          <div className="bg-[#FDF6E8] rounded-3xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-1618">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-[#0E3A47]/60 hover:text-[#0E3A47]" data-id="element-1619">
              <XIcon className="w-6 h-6" data-id="element-1620" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-1621">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="500" width="330" title="Webinar Communicating With Your Dog Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-1622"></iframe>
            </div>
            <p className="text-xs text-[#0E3A47]/60 text-center mt-3" data-id="element-1623">
              We HATE spam. Your email address is 100% safe.
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-1624">
              <img src="https://cdn.magicpatterns.com/uploads/wQrcUm6zAwuNUwj7w8yvR2/Ontwerp_zonder_titel_(15).jpg" alt="Jess" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-1625" />
              <p className="text-xs text-[#0E3A47]/70 leading-snug" data-id="element-1626">
                This webinar is hosted by Jess, qualified dog trainer with years
                of experiences.
              </p>
            </div>
          </div>
        </div>}

      {/* Top marquee bar */}
      <TopMarquee data-id="element-1627" />

      {/* Navigation */}
      <nav className="w-full px-4 pt-6 pb-2 flex justify-center" data-id="element-1628">
        <div className="bg-[#FFF9F2] rounded-full px-6 py-3 flex flex-col md:flex-row items-center md:justify-between gap-3 md:gap-6 w-full max-w-5xl shadow-lg" data-id="element-1629">
          <img src="https://cdn.magicpatterns.com/uploads/u6HqvoxwaxEaGjC96AKc5M/Logo_Dark_with_Dark_Logotype.svg" alt="Stressless Dogs" className="h-8 object-contain md:hidden" data-id="element-1630" />
          <img src="https://cdn.magicpatterns.com/uploads/168WzXd726wkMCdrAqmyRM/Logo_Icon_Dark_(1).png" alt="Stressless Dogs" className="hidden md:block h-9 object-contain" data-id="element-1631" />
          <div className="hidden md:block w-[520px] flex-shrink-0" data-id="element-1632">
            <div className="trustpilot-widget" data-locale="en-US" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="23019ce4-308c-4f1c-8406-ce6ca64ac0c2" data-id="element-1633">
              <a href="https://www.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-1634">
                Trustpilot
              </a>
            </div>
          </div>
          <p className="text-xs md:text-sm text-[#003841]/80 text-center md:text-right leading-snug" data-id="element-1635">
            Questions? Email us at{' '}
            <a href="mailto:amee@stresslessdogs.nl" className="font-semibold text-[#003841] hover:text-[#E16A5F] transition-colors" data-id="element-1636">
              amee@stresslessdogs.nl
            </a>
          </p>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative overflow-hidden" data-id="element-1637">
        <img src="https://cdn.magicpatterns.com/uploads/wwgxF2jfrhgpV5vrRDbiAH/Paw_Icon_Warm_White.png" alt="" aria-hidden="true" className="pointer-events-none select-none absolute top-16 right-4 md:top-12 md:-right-16 w-80 md:w-96 opacity-20 -rotate-12 z-0" data-id="element-1638" />
        <div className="relative z-10 max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-1639">
          <div className="md:col-span-7" data-id="element-1640">
            <div className="flex justify-center md:justify-start mb-5" data-id="element-1641">
              <div className="inline-flex items-center gap-2" data-id="element-1642">
                <span className="block w-2 h-2 rounded-full bg-[#E8806E]" data-id="element-1643" />
                <span className="text-[#E8806E] text-xs md:text-sm font-bold uppercase tracking-[0.18em]" data-id="element-1644">
                  Free Online Webinar
                </span>
              </div>
            </div>
            <h1 className="text-2xl md:text-3xl font-extrabold text-[#0E3A47] mb-6 leading-tight text-center md:text-left" data-id="element-1645">
              Become Fluent in Dog - Stress-Free Communication That Helps Your
              Dog Understand You, Stop Problem Behaviors, and Learn to Read the
              'Why' Behind Everything Your Dog Does
            </h1>
            <div className="md:hidden relative w-fit mx-auto mt-20 mb-4" data-id="element-1646">
              {/* Playful dogs peeking out from behind the CTA */}
              <img src="https://cdn.magicpatterns.com/uploads/pgU8CUcvHpxw2NNdG1QxFZ/Dog_14_(1).png" alt="" aria-hidden="true" className="absolute left-0 -translate-x-[55%] -top-10 w-20 h-20 object-contain object-bottom pointer-events-none select-none z-0 -rotate-12" data-id="element-1647" />
              <img src="https://cdn.magicpatterns.com/uploads/nzshiV8MPUsfBAmbDmrRJ2/Jess_(1).png" alt="" aria-hidden="true" className="absolute right-0 translate-x-[55%] -top-20 w-28 h-28 object-contain object-bottom pointer-events-none select-none z-0 rotate-6" data-id="element-1648" />
              <button onClick={() => setIsPopupOpen(true)} className="relative z-10 bg-[#E8806E] hover:bg-[#D26E5C] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-1649">
                Register for webinar
              </button>
            </div>
            <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-1650">
              <div className="flex -space-x-3" data-id="element-1651">
                <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-[#FBF1DC]" alt="User" data-id="element-1652" />
                <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-[#FBF1DC]" alt="User" data-id="element-1653" />
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-[#FBF1DC]" alt="User" data-id="element-1654" />
              </div>
              <div data-id="element-1655">
                <p className="font-bold text-lg text-[#0E3A47]" data-id="element-1656">97,283+</p>
                <p className="text-xs text-[#0E3A47]/70" data-id="element-1657">
                  Dog owners already attended this webinar
                </p>
              </div>
            </div>
            <p className="text-lg text-[#0E3A47]/80 mb-8 leading-relaxed" data-id="element-1658">
              Simple techniques. Better understanding. Zero stress. Free
              90-minute online webinar. You'll learn:
            </p>

            <ul className="space-y-4 mb-8" data-id="element-1659">
              {["The language of your dog - learn to read your dog's signals so you see what he's thinking, feeling, and needing", 'What anxiety, stress, and insecurity really mean - and how to help your dog with them', "Why 'disobedience' is a myth - and how to make sure your dog always knows what you want", "How to see the world from your dog's perspective - so 'unexplained behavior' suddenly makes sense", 'The 3 core needs of every dog - and how meeting them creates a calmer, happier companion'].map((item, i) => <li key={i} className="flex items-start" data-id="element-1660">
                  <Check className="w-6 h-6 text-[#E8806E] mr-3 flex-shrink-0 mt-0.5" data-id="element-1661" />
                  <span className="text-[#0E3A47]/85 font-medium" data-id="element-1662">{item}</span>
                </li>)}
            </ul>

            <div className="hidden md:flex items-center gap-4" data-id="element-1663">
              <div className="flex -space-x-3" data-id="element-1664">
                <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-[#FBF1DC]" alt="User" data-id="element-1665" />
                <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-[#FBF1DC]" alt="User" data-id="element-1666" />
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-[#FBF1DC]" alt="User" data-id="element-1667" />
              </div>
              <div data-id="element-1668">
                <p className="font-bold text-xl text-[#0E3A47]" data-id="element-1669">97,283+</p>
                <p className="text-sm text-[#0E3A47]/70" data-id="element-1670">
                  Dog owners already attended this webinar
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-5 flex justify-center" data-id="element-1671">
            <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-1672">
              <div className="flex justify-center items-center w-full" data-id="element-1673">
                <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communicating With Your Dog Stressless Dogs" style={{
                border: 'none',
                borderRadius: '25px',
                backgroundColor: 'white',
                maxWidth: '100%'
              }} data-id="element-1674"></iframe>
              </div>
              {/* Host avatar + handwritten note pointing UP at the form */}
              <div className="relative mt-2 flex items-start gap-3 pl-2" data-id="element-1675">
                {/* Playful curved arrow pointing UP to the center of the form's bottom edge */}
                <svg className="absolute -top-3 left-1/2 -translate-x-1/2 w-16 h-16 md:w-20 md:h-20 text-[#E8806E]" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-1676">
                  <path d="M15,90 Q 25,55 50,15" stroke="currentColor" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-1677" />
                  <path d="M40,22 L 50,10 L 60,24" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-1678" />
                </svg>
                <div className="relative flex-shrink-0 mt-12" data-id="element-1679">
                  <img src="https://cdn.magicpatterns.com/uploads/8ysTypu2zSP2JMgrYfLdmk/Ontwerp_zonder_titel_(14).jpg" alt="Jess, host of the webinar" className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-4 border-[#FBF1DC] shadow-lg" data-id="element-1680" />
                  <span className="absolute -bottom-1 -right-1 w-5 h-5 md:w-6 md:h-6 bg-[#E8806E] rounded-full border-2 border-[#FBF1DC] flex items-center justify-center" data-id="element-1681">
                    <span className="w-1.5 h-1.5 md:w-2 md:h-2 bg-white rounded-full" data-id="element-1682"></span>
                  </span>
                </div>
                <p className="text-[#0E3A47] text-lg md:text-xl leading-tight max-w-[160px] mt-14" style={{
                fontFamily: "'Caveat', cursive",
                fontWeight: 700
              }} data-id="element-1683">
                  Hi! I'm Jess, your host for this webinar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <CurvedDivider topColor="#FBF1DC" bottomColor="#95CBCD" direction="down" data-id="element-1684" />
      <section className="bg-[#95CBCD] relative overflow-hidden" data-id="element-1685">
        <img src="https://cdn.magicpatterns.com/uploads/qrxPhSaWZMGbDQ2MBk31kV/Heart_Icon_Warm_White.png" alt="" aria-hidden="true" className="pointer-events-none select-none absolute bottom-16 left-4 md:bottom-12 md:-left-20 w-80 md:w-[28rem] opacity-25 rotate-[15deg] z-0" data-id="element-1686" />
        <div className="relative z-10 max-w-6xl mx-auto px-4 text-center pt-8 pb-20" data-id="element-1687">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0E3A47] mb-16" data-id="element-1688">
            Learn your dog's language in three steps
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-1689">
            <div className="flex flex-col items-center" data-id="element-1690">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Calendar icon" className="w-32 h-32 object-contain mb-6" data-id="element-1691" />
              <h3 className="text-xl font-bold text-[#0E3A47] mb-3" data-id="element-1692">Step 1.</h3>
              <p className="text-[#0E3A47]/75" data-id="element-1693">
                Fill out the form and reserve your spot
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-1694">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar button icon" className="w-32 h-32 object-contain mb-6" data-id="element-1695" />
              <h3 className="text-xl font-bold text-[#0E3A47] mb-3" data-id="element-1696">Step 2.</h3>
              <p className="text-[#0E3A47]/75" data-id="element-1697">
                When it is time, click the link in your email to join right away
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-1698">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Woman cuddling dog" className="w-32 h-32 object-contain mb-6" data-id="element-1699" />
              <h3 className="text-xl font-bold text-[#0E3A47] mb-3" data-id="element-1700">Step 3.</h3>
              <p className="text-[#0E3A47]/75" data-id="element-1701">
                Learn in 90 minutes how to speak your dog's language
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#E8806E] hover:bg-[#D26E5C] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-1702">
            Register for webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <CurvedDivider topColor="#95CBCD" bottomColor="#003841" direction="down" data-id="element-1703" />
      <section className="bg-[#003841] relative overflow-hidden" data-id="element-1704">
        <img src="https://cdn.magicpatterns.com/uploads/9WXb2ivRHstKthbdCMaxCu/Dog_Icon_Warm_White.png" alt="" aria-hidden="true" className="pointer-events-none select-none absolute top-24 right-4 md:-right-24 w-72 md:w-96 opacity-10 -rotate-6 z-0" data-id="element-1705" />
        <div className="relative z-10 max-w-6xl mx-auto px-4 text-center pt-8 pb-20" data-id="element-1706">
          <h2 className="text-3xl md:text-4xl font-bold text-[#e9edef] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-1707">
            Thousands of owners went before you - and they all say the same
            thing: <br data-id="element-1708" />
            <span className="italic" data-id="element-1709">"I finally truly understand my dog."</span>
          </h2>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-1710">
            <div className="bg-[#FDF6E8] border border-[#0E3A47]/10 rounded-2xl p-6 shadow-sm" data-id="element-1711">
              <div className="flex items-center mb-4" data-id="element-1712">
                <div className="flex text-[#E8806E] mr-2" data-id="element-1713">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-1714" />)}
                </div>
                <span className="text-sm text-[#0E3A47]/60" data-id="element-1715">Jul 8, 2024</span>
              </div>
              <h4 className="font-bold text-[#0E3A47] mb-2" data-id="element-1716">
                Really lovely course. A must-have, even for experienced dog
                lovers.
              </h4>
              <p className="text-[#0E3A47]/80 text-sm leading-relaxed" data-id="element-1717">
                We always have rehomed dogs, so we are used to a lot. But with
                our most recent rescue we really needed help. In a short time we
                already learned so much and got such clear guidance. I am
                incredibly enthusiastic about this course and I was offered a
                lot of support too. It is neatly organized and clear, but what
                appeals to me most is that it works without commands - through
                communication.
              </p>
              <p className="text-sm font-semibold text-[#0E3A47] mt-4" data-id="element-1718">
                - Nicolette
              </p>
            </div>

            <div className="bg-[#FDF6E8] border border-[#0E3A47]/10 rounded-2xl p-6 shadow-sm" data-id="element-1719">
              <div className="flex items-center mb-4" data-id="element-1720">
                <div className="flex text-[#E8806E] mr-2" data-id="element-1721">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-1722" />)}
                </div>
                <span className="text-sm text-[#0E3A47]/60" data-id="element-1723">Sep 3, 2024</span>
              </div>
              <h4 className="font-bold text-[#0E3A47] mb-2" data-id="element-1724">
                Not good - outstanding!
              </h4>
              <p className="text-[#0E3A47]/80 text-sm leading-relaxed" data-id="element-1725">
                Amée is a wonderfully kind woman with a heart for dogs, and you
                can really feel it. The tips genuinely help. I recommend this
                course to everyone with puppies, young dogs and dogs of any
                other age - especially people who are struggling with their
                companion. Both behavioral and medical issues. Just watch the
                free masterclass and you will be completely convinced of the
                course and the people behind it. Lots of love to the entire
                team.
              </p>
              <p className="text-sm font-semibold text-[#0E3A47] mt-4" data-id="element-1726">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-[#FDF6E8] border border-[#0E3A47]/10 rounded-2xl p-6 shadow-sm" data-id="element-1727">
              <div className="flex items-center mb-4" data-id="element-1728">
                <div className="flex text-[#E8806E] mr-2" data-id="element-1729">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-1730" />)}
                </div>
                <span className="text-sm text-[#0E3A47]/60" data-id="element-1731">Apr 20, 2024</span>
              </div>
              <h4 className="font-bold text-[#0E3A47] mb-2" data-id="element-1732">
                This was the first time I took an online dog course...
              </h4>
              <p className="text-[#0E3A47]/80 text-sm leading-relaxed" data-id="element-1733">
                This was the first time I took an online dog course and I
                learned a lot from it. Although my dogs (mostly) behave well, I
                mainly wanted to learn what I could do better myself when it
                comes to communication. That worked: it really stands out that
                because I now carry myself differently, my dogs communicate much
                more calmly with other dogs. Especially with unfamiliar dogs
                there used to be a lot of barking. Now barely at all -
                wonderful, walking is a joy again. Truly: stressless!
              </p>
              <p className="text-sm font-semibold text-[#0E3A47] mt-4" data-id="element-1734">
                - Margreet
              </p>
            </div>

            <div className="bg-[#FDF6E8] border border-[#0E3A47]/10 rounded-2xl p-6 shadow-sm" data-id="element-1735">
              <div className="flex items-center mb-4" data-id="element-1736">
                <div className="flex text-[#E8806E] mr-2" data-id="element-1737">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-1738" />)}
                </div>
                <span className="text-sm text-[#0E3A47]/60" data-id="element-1739">Aug 13, 2024</span>
              </div>
              <h4 className="font-bold text-[#0E3A47] mb-2" data-id="element-1740">
                I enjoyed refreshing my knowledge...
              </h4>
              <p className="text-[#0E3A47]/80 text-sm leading-relaxed" data-id="element-1741">
                I enjoyed refreshing my knowledge and being well-prepared for
                the puppy I will be getting soon. Great work!
              </p>
              <p className="text-sm font-semibold text-[#0E3A47] mt-4" data-id="element-1742">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#E8806E] hover:bg-[#D26E5C] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-1743">
            Register for webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <CurvedDivider topColor="#003841" bottomColor="#FBECD5" direction="down" data-id="element-1744" />
      <section className="bg-[#FBECD5] relative overflow-hidden" data-id="element-1745">
        <img src="https://cdn.magicpatterns.com/uploads/wwgxF2jfrhgpV5vrRDbiAH/Paw_Icon_Warm_White.png" alt="" aria-hidden="true" className="pointer-events-none select-none absolute bottom-16 left-4 md:bottom-12 md:-left-16 w-80 md:w-[26rem] opacity-25 rotate-[20deg] z-0" data-id="element-1746" />
        <div className="relative z-10 max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center pt-8 pb-20" data-id="element-1747">
          <div data-id="element-1748">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0E3A47] mb-6 leading-tight" data-id="element-1749">
              Hi, I'm Jess - and I'm hosting this webinar.
            </h2>
            <div className="space-y-4 text-[#0E3A47]/80 leading-relaxed" data-id="element-1750">
              <p data-id="element-1751">
                I can always remember having loved dogs. Their boundless love
                and optimism remind me that every day is an opportunity for joy!
                For me, dog training is all about enhancing the human-dog
                relationship, helping us to live our best lives together.
              </p>
              <p data-id="element-1752">
                I believe passionately in using fear-free, science-backed
                training methods, without relying on pain, discomfort or
                punishment. I am a lifetime member of the Dog Training College,
                have studied with the Victoria Stilwell Academy, and have
                trained with the IMDT and the School of Canine Science.
              </p>
              <p data-id="element-1753">
                In addition to my dog training certifications, I am also a fully
                qualified teacher with a Masters in Education & Learning Theory,
                and I taught primary school children for five years. My teaching
                experience means I can deliver dog training in a way that is
                easy to understand and simple to follow for the whole family.
              </p>
            </div>
          </div>
          <div className="rounded-3xl overflow-hidden shadow-xl" data-id="element-1754">
            <img src="https://cdn.magicpatterns.com/uploads/4ngSn9K9mzmxmuFEdUUb2F/Ontwerp_zonder_titel_(15).jpg" alt="Jess with her dog" className="w-full h-auto object-cover" data-id="element-1755" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <CurvedDivider topColor="#FBECD5" bottomColor="#95CBCD" direction="down" data-id="element-1756" />
      <section className="bg-[#95CBCD] relative overflow-hidden" data-id="element-1757">
        <img src="https://cdn.magicpatterns.com/uploads/qrxPhSaWZMGbDQ2MBk31kV/Heart_Icon_Warm_White.png" alt="" aria-hidden="true" className="pointer-events-none select-none absolute top-12 right-4 md:top-12 md:-right-20 w-72 md:w-96 opacity-25 -rotate-[10deg] z-0" data-id="element-1758" />
        <div className="relative z-10 max-w-md mx-auto px-4 pt-8 pb-20" data-id="element-1759">
          <div className="p-6 rounded-3xl w-full" data-id="element-1760">
            <div className="flex justify-center items-center" data-id="element-1761">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communicating With Your Dog Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-1762"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <CurvedDivider topColor="#95CBCD" bottomColor="#F5E6CC" direction="down" data-id="element-1763" />
      <footer className="bg-[#F5E6CC] relative overflow-hidden" data-id="element-1764">
        <img src="https://cdn.magicpatterns.com/uploads/9WXb2ivRHstKthbdCMaxCu/Dog_Icon_Warm_White.png" alt="" aria-hidden="true" className="pointer-events-none select-none absolute bottom-[2px] left-1/2 -translate-x-1/2 md:bottom-[2px] w-60 md:w-[21rem] opacity-25 rotate-[8deg] z-0" data-id="element-1765" />
        <div className="relative z-10 max-w-6xl mx-auto px-4 flex flex-col items-center text-center pt-8 pb-12" data-id="element-1766">
          <img src="https://cdn.magicpatterns.com/uploads/168WzXd726wkMCdrAqmyRM/Logo_Icon_Dark_(1).png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-1767" />
          <p className="font-semibold text-[#0E3A47] mb-2" data-id="element-1768">
            For loving dog owners
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-[#E8806E] hover:text-[#D26E5C] hover:underline mb-8 font-medium" data-id="element-1769">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-[#0E3A47]/60 max-w-3xl leading-relaxed" data-id="element-1770">
            <p className="mb-2" data-id="element-1771">
              © 2025 Stressless Dogs. All rights reserved.
            </p>
            <p data-id="element-1772">
              This website uses cookies and similar technologies for analytics
              and advertising purposes. This page is an advertorial for
              Stressless Dogs. Stressless Dogs is an independent company and is
              in no way affiliated with or part of Meta (formerly Facebook).
              This advertisement is shown through the Meta advertising platform,
              but Meta is not responsible for the content or services offered by
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-1773" />
    </div>;
}